// import React from "react";
import React, { useState, useEffect } from "react";
import logo from "../../src/assets/images/logo.png"; // Adjust the path as necessary

const LoadingScreen = () => {
  const [messageIndex, setMessageIndex] = useState(0);

  const messages = [
    "We are loading for you...",
    "Doing our magic...",
    "Gathering the bits and bytes...",
    "Aligning the stars...",
    "Polishing the pixels...",
    "Almost there..."
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % messages.length);
    }, 850); // Changes text every 2.5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={styles.container}>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @keyframes pulse {
            0% { transform: scale(1); opacity: 1; }
            50% { transform: scale(0.95); opacity: 0.8; }
            100% { transform: scale(1); opacity: 1; }
          }
          @keyframes fadeText {
            0% { opacity: 0.4; transform: translateY(5px); }
            100% { opacity: 1; transform: translateY(0px); }
          }
        `}
      </style>

      <div style={styles.loaderBox}>
        {/* The Spinning Ring */}
        <div style={styles.spinner}></div>
        
        {/* The Logo in the center */}
        <div style={styles.logoWrapper}>
          <img src={logo} alt="Loading..." style={styles.logo} />
        </div>
      </div>

      {/* Dynamic Text Area */}
      <div style={styles.textContainer}>
        {/* We use a key here to trigger the fade animation on every change */}
        <p key={messageIndex} style={styles.loadingText}>
          {messages[messageIndex]}
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "#151525", // Dark Navy Background
    color: "#fff",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  loaderBox: {
    position: "relative",
    width: "140px",
    height: "140px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "30px",
  },
  spinner: {
    position: "absolute",
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    border: "4px solid transparent",
    borderTopColor: "#9ACA3C", // Your Logo Lime Green
    borderBottomColor: "#4A4A75", // Lighter Navy
    animation: "spin 1.2s linear infinite",
  },
  logoWrapper: {
    animation: "pulse 2s ease-in-out infinite",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  logo: {
    width: "70px",
    height: "auto",
    objectFit: "contain",
  },
  textContainer: {
    height: "30px", // Fixed height prevents jumping when text changes
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loadingText: {
    margin: 0,
    fontSize: "1.1rem",
    letterSpacing: "1px",
    color: "#9ACA3C", // Lime Green text
    opacity: 0.9,
    animation: "fadeText 0.5s ease-out forwards", // Text slides up slightly when appearing
  },
};

export default LoadingScreen;